/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSignalH = createReactComponent("signal-h", "IconSignalH", [
  ["path", { d: "M10 16v-8", key: "svg-0" }],
  ["path", { d: "M14 8v8", key: "svg-1" }],
  ["path", { d: "M10 12h4", key: "svg-2" }]
]);

export { IconSignalH as default };
//# sourceMappingURL=IconSignalH.js.map
